"use client";
import { jsx as a } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import { css as i, cx as m } from "@/styled-system/css";
import { bannerActionRecipe as p } from "./styles/banner-action.styles.js";
const f = e(
  (n, o) => {
    const { className: r, css: s, ...c } = n, t = i(p, s);
    return /* @__PURE__ */ a(
      "div",
      {
        ref: o,
        "data-c11n-component": "Banner.Action",
        "data-c11n-version": "10.0.0-alpha.19",
        className: m("c11n", t, r),
        ...c
      }
    );
  }
);
f.displayName = "Banner.Action";
export {
  f as BannerAction
};
//# sourceMappingURL=banner-action.js.map
